import { useState } from 'react'

import { EMPTY_OBJECT } from '../../../../constants/common'

export function useEmailFormResize({
  initialFullScreen = false,
  onExitFromFullScreen,
} = EMPTY_OBJECT) {
  const [fullScreen, setFullScreen] = useState(initialFullScreen)

  function handleResizeModal() {
    setFullScreen(prev => {
      if (onExitFromFullScreen) {
        if (prev) {
          onExitFromFullScreen()
        }

        return undefined
      }

      return !prev
    })
  }

  return { fullScreen, handleResizeModal }
}
